var s = (e, r, o) => new Promise((c, a) => {
  var g = (n) => {
    try {
      t(o.next(n));
    } catch (d) {
      a(d);
    }
  }, l = (n) => {
    try {
      t(o.throw(n));
    } catch (d) {
      a(d);
    }
  }, t = (n) => n.done ? c(n.value) : Promise.resolve(n.value).then(g, l);
  t((o = o.apply(e, r)).next());
});
import { selfAxios as i } from "@oppein/op-utils";
function p(e) {
  return s(this, null, function* () {
    const {
      data: r
    } = yield i.get(
      "/designordercenter/customerOrderPlace/closeLocalByOrderId",
      { params: e }
    );
    return r;
  });
}
function y(e) {
  return s(this, null, function* () {
    const {
      data: r
    } = yield i.post(
      "/production-order/engineering/salesEngineeringOrder/closeOrder",
      e
    );
    return r;
  });
}
function f(e) {
  return s(this, null, function* () {
    const {
      data: r
    } = yield i.post(
      "/production-order/engineering/salesEngineeringOrder/closeByIds",
      e
    );
    return r;
  });
}
export {
  f as closeByIds,
  p as productionOrderCloseOrder,
  y as salesEngineeringOrderCloseOrder
};



//////////////////
// WEBPACK FOOTER
// ./~/@oppein/op-web-components/dist/es/request/mtdsretail/post.js
// module id = 1829
// module chunks = 67